import { SignupPlan } from '@blazebite/shared-models';

/** Funnel plan id — owned by @blazebite/shared-models (SignupPlan). */
export type Plan = SignupPlan;
export interface PlanDetails {
    name: Plan;
    displayName: string;
    tagline: string;
    /** Short one-card summary used by the plan picker. */
    summary?: string;
    monthlyPrice: string;
    annualMonthlyPrice: string;
    annualPrice: string;
    features: string[];
    annualDiscountMessage?: string;
    descriptionLine1: string;
    descriptionLine2: string;
    descriptionLine3: string;
  }

/** The four service plans, shared by the plan picker and the review page. */
export const PLAN_CATALOG: PlanDetails[] = [
  {
    name: 'starter',
    displayName: 'Starter',
    tagline: 'Ideal for Smaller venues, occasional events, and pop-up activities',
    summary: 'Pop-ups and occasional events. Unlimited orders, 10% convenience fee per transaction.',
    monthlyPrice: '0',
    annualMonthlyPrice: '0',
    annualPrice: '0',
    descriptionLine1: 'No monthly fees',
    descriptionLine2: 'UNLIMITED orders per/month',
    descriptionLine3: '10% convenience fee per transaction',
    features: ['Basic Mobile Ordering Setup',
               'Access to Reporting',
               'Online Payments (credit card, Apple Pay, Google Pay)',
               'Menu Customizations',
               'Volunteer Training',
               'Push notifications for orders',
               'Customer Response Team']
  },
  {
    name: 'nonprofit',
    displayName: 'Non-Profit',
    tagline: 'Ideal for 501(c)(3) Non-Profit Schools (Booster Clubs, CYO)',
    summary: '501(c)(3) schools and booster clubs. 2,000 orders/mo, no convenience fee, interactive reporting.',
    monthlyPrice: '44',
    annualMonthlyPrice: '39',
    annualPrice: '468',
    descriptionLine1: 'billed monthly/annually',
    descriptionLine2: 'Up to 2,000 orders per/month',
    descriptionLine3: 'NO CONVENIENCE FEE',
    features: ['All Free Plan Features',
               'Interactive Reporting Dashboard',
               'Order Ahead/Pre-Orders',
               'Dedicated Support Line',
               'Sponsorship Opportunities for Additional Revenue',
               'Marketing Materials & Signage']
  },
  {
    name: 'essential',
    displayName: 'Essential',
    tagline: 'Ideal for concession-based business (golf courses, food trucks, concerts)',
    summary: 'Golf courses, food trucks and concerts. 2,000 orders/mo, no convenience fee.',
    monthlyPrice: '69',
    annualMonthlyPrice: '59',
    annualPrice: '708',
    descriptionLine1: 'billed monthly/annually',
    descriptionLine2: 'Up to 2,000 orders per/month',
    descriptionLine3: 'NO CONVENIENCE FEE',
    features: ['All Free Plan Features',
               'Interactive Reporting Dashboard',
               'Order Ahead/Pre-Orders',
               'Dedicated Support Line',
               'Sponsorship Opportunities for Additional Revenue',
               'Marketing Materials & Signage']
  },
  {
    name: 'enterprise',
    displayName: 'Enterprise',
    tagline: 'Ideal for LARGE concession stands (stadiums, arenas, colleges)',
    summary: 'Stadiums, arenas and colleges. 10,000 orders/mo, API access, priority support.',
    monthlyPrice: '144',
    annualMonthlyPrice: '129',
    annualPrice: '1548',
    descriptionLine1: 'billed monthly/annually',
    descriptionLine2: 'Up to 10,000 orders per/month',
    descriptionLine3: 'NO CONVENIENCE FEE',
    features: ['All Essential Plan Features',
               'API Access for Integration',
               'Personal Support Rep',
               'Remote Log-in to Tablet',
               'Priority Updates and Features',
               'Staff App',
               'Custom Marketing Campaigns',
               'Discounts on Multiple Units']
  }
];